import { ActivitySearchTimeType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const activitySearchTimeName: { [key in ActivitySearchTimeType]: TKeyType } = {
  [ActivitySearchTimeType.APPLIED_TIME]: 'common.applyDate',
  [ActivitySearchTimeType.UPDATED_TIME]: 'common.updatedDate'
}

export default activitySearchTimeName
